import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoFull = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 24,
	viewBox: "0 0 120 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3079_10119)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M21.892 15.4723C21.7549 15.0066 21.4687 14.575 21.0652 14.2254L19.8954 13.212L17.9961 14.8578L19.3996 16.0755C19.4443 16.1139 19.4699 16.1702 19.4699 16.2293C19.4699 16.2884 19.4443 16.3447 19.3996 16.3831L15.0661 20.1382C12.9395 21.9811 9.73176 21.9804 7.60514 20.1382L3.39308 16.4885C2.81064 15.9843 2.4768 15.2523 2.4768 14.481V9.51896C2.4768 8.74773 2.81064 8.01567 3.39308 7.51148L7.60585 3.86185C8.63435 2.97027 9.95906 2.47962 11.3363 2.47962C12.7136 2.47962 14.0383 2.97027 15.0668 3.86185L19.4067 7.62186C19.4514 7.66032 19.477 7.71658 19.477 7.77568C19.477 7.83479 19.4514 7.89105 19.4067 7.9295L11.3363 14.9218L7.96455 12.0007L11.3363 9.07887L13.3074 10.7894L15.2032 9.14652L12.7903 7.05572C11.9614 6.3379 10.7113 6.3379 9.88234 7.05572L6.04249 10.3828C5.57369 10.7894 5.30449 11.3783 5.30449 12C5.30449 12.6217 5.57369 13.2113 6.04249 13.6172L9.88234 16.9443C10.7113 17.6628 11.9614 17.6628 12.7903 16.9443L21.0659 9.7739C21.4694 9.42425 21.7549 8.99341 21.8927 8.52697C22.1825 7.5421 21.8736 6.47606 21.1057 5.81022L16.6877 1.98184C15.1613 0.660851 13.2484 0 11.3363 0C9.4242 0 7.51138 0.660851 5.98566 1.98184L1.77361 5.63148C0.646369 6.60851 0 8.02492 0 9.51896V14.481C0 15.9744 0.646369 17.3915 1.77361 18.3685L5.98566 22.0182C7.46095 23.2964 9.36099 24 11.3356 24C13.3102 24 15.211 23.2964 16.6863 22.0182L21.1043 18.1898C21.8728 17.5239 22.1818 16.4572 21.8913 15.473L21.892 15.4723Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.2317 4.93111C43.8812 4.93111 46.5605 6.55553 47.6284 9.24961L45.1633 10.4724C44.3674 8.54244 42.6975 7.39588 40.2512 7.39588C37.2037 7.39588 34.9122 9.23038 34.9122 12.0007C34.9122 14.7709 37.203 16.6055 40.2512 16.6055C42.6975 16.6055 44.3667 15.4589 45.1633 13.5289L47.6284 14.7517C46.5605 17.4458 43.8819 19.0702 40.2317 19.0702C35.5142 19.0702 32 16.0699 32 12C32 7.92999 35.5135 4.92969 40.2317 4.92969V4.93111Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.6385 5.14062L64.6663 18.8603H61.5797L59.9683 15.6691H52.0861L50.4553 18.8603H47.4077L54.4354 5.14062H57.6385ZM53.2901 13.2805H58.7456L56.028 7.91162L53.2908 13.2805H53.2901Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66.5826 13.9139C68.1744 16.0161 70.6981 16.6656 72.7558 16.6656C75.0856 16.6656 76.736 15.9777 76.736 14.8696C76.736 13.5706 75.5906 13.4552 71.6691 13.0351C68.2525 12.6526 65.6311 12.0224 65.6311 9.30907C65.6311 6.59576 68.2134 4.93359 72.1734 4.93359C75.2795 4.93359 78.0753 6.02248 79.3371 7.66613L77.4342 9.46218C76.3663 8.10553 74.3867 7.32216 72.0178 7.32216C69.5332 7.32216 68.4066 8.10553 68.4066 9.02278C68.4066 10.0162 69.3385 10.2455 72.8716 10.6472C76.8322 11.0866 79.6272 11.6029 79.6272 14.5641C79.6272 17.5252 76.579 19.0734 72.6379 19.0734C69.3183 19.0734 66.0182 17.8122 64.6587 15.8822L66.5811 13.9139H66.5826Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M89.6702 7.56765V18.8603H86.797V7.56765H80.6426V5.14062H95.8239V7.56765H89.6702Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M109.143 5.14062L116.171 18.8603H113.084L111.473 15.6691H103.591L101.96 18.8603H98.9121L105.94 5.14062H109.143ZM104.794 13.2805H110.249L107.531 7.91162L104.794 13.2805Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.131 18.8603H117.278V5.14062H120.131V18.8603Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3079_10119",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 24,
			fill: "transparent"
		})
	}) })]
});
export default SvgLogoFull;
